import { createSlice } from "@reduxjs/toolkit";

export const modalSlice = createSlice({
  name: "modal",
  initialState: {
    status: false,
    orderModal: false,
  },
  reducers: {
    setModal: (state, action) => {
      return {
        ...state,
        status: action.payload,
      };
    },
    setOrderModal: (state, action) => {
      return {
        ...state,
        orderModal: action.payload,
      };
    },
  },
});

export const { setModal, setOrderModal } = modalSlice.actions;

export default modalSlice.reducer;
